import { compose } from 'redux'
import withType from 'components/common/hoc/withType'
import flags from 'components/common/hoc/flags'
import BOTAccountPersonalInformation from './BOTAccountPersonalInformation'

export default compose(
  withType({ type: 'BOTAccountPersonalInformation' }),
  flags
)(BOTAccountPersonalInformation)
